import type { ReactNode } from 'react';
import React from 'react';
import type { FragmentType, MinimalUserFragmentDoc } from '@graphql/reactQuery';
import { MinimalUser } from '../MinimalUser';

const AVATAR_SIZE = 20;

export const HeroInfo = ({
  userFrag,
  primaryInfo,
  secondaryInfo,
}: {
  userFrag: FragmentType<MinimalUserFragmentDoc>;
  primaryInfo: ReactNode;
  secondaryInfo: ReactNode;
}) => {
  return (
    <div
      className="group z-above1 flex items-center whitespace-nowrap font-base text-base-m text-base300 duration-300 [&_.username:hover]:brightness-130 [&_.username]:text-base300 [&_.username]:transition-[filter]
    md:[&_.username]:max-w-none
    "
    >
      <MinimalUser
        avatarSize={AVATAR_SIZE}
        borderRadius={AVATAR_SIZE}
        userFrag={userFrag}
        gap={6}
        hideAvatarOnMobile
        hideVerified
        imagePriority
      />
      {primaryInfo && (
        <>
          <span className="mx-2">•</span>
          {primaryInfo}
        </>
      )}
      {secondaryInfo && (
        <>
          <span className="mx-2">•</span>
          {secondaryInfo}
        </>
      )}
    </div>
  );
};
